/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputDirection
 */
export interface OutputDirection {
    /**
     * 
     * @type {string}
     * @memberof OutputDirection
     */
    coordinates: string;
    /**
     * 
     * @type {string}
     * @memberof OutputDirection
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OutputDirection
     */
    type: string;
}

/**
 * Check if a given object implements the OutputDirection interface.
 */
export function instanceOfOutputDirection(value: object): boolean {
    if (!('coordinates' in value)) return false;
    if (!('name' in value)) return false;
    if (!('type' in value)) return false;
    return true;
}

export function OutputDirectionFromJSON(json: any): OutputDirection {
    return OutputDirectionFromJSONTyped(json, false);
}

export function OutputDirectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputDirection {
    if (json == null) {
        return json;
    }
    return {
        
        'coordinates': json['coordinates'],
        'name': json['name'],
        'type': json['type'],
    };
}

export function OutputDirectionToJSON(value?: OutputDirection | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'coordinates': value['coordinates'],
        'name': value['name'],
        'type': value['type'],
    };
}

